import React from "react";
import { ChevronLeft, ChevronRight, Download } from "lucide-react";
import CustomDatePicker from "../../components/CustomDatePicker";
import { FINANCE_ICONS } from "./financeConstants";

export default function FinanceMobileHeaderActions({
  onOpenExcel,
  onPrevMonth,
  onNextMonth,
  currentDate,
  currentDateStr,
  onChangeMonth,
  theme,
}) {
  return (
    <div className="sticky top-0 z-30 bg-[#F0F0EB]/95 backdrop-blur-xl border-b border-white/60 px-3 pt-2 pb-2 shadow-sm space-y-2">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2.5 min-w-0">
          <div className="w-8 h-8 bg-white rounded-xl flex items-center justify-center shadow-sm border border-gray-100">
            <img src={FINANCE_ICONS.wallet} alt="" className="w-5 h-5 object-contain" />
          </div>
          <h1 className="text-[15px] font-black text-gray-800 truncate">재정 관리</h1>
        </div>

        <div className="flex items-center gap-1.5">
          <button
            onClick={onOpenExcel}
            className="h-9 px-2.5 bg-white border border-gray-200 rounded-xl text-[11px] font-bold text-emerald-600 shadow-sm active:scale-95 transition-all flex items-center gap-1"
            title="엑셀 다운로드"
          >
            <Download size={14} />
            <span>엑셀</span>
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-2 border border-gray-100 shadow-sm flex items-center justify-between">
        <button onClick={onPrevMonth} className="w-9 h-9 hover:bg-gray-50 rounded-xl transition flex items-center justify-center">
          <ChevronLeft size={18} className="text-gray-400" />
        </button>
        <CustomDatePicker
          theme={theme}
          value={currentDateStr}
          onChange={onChangeMonth}
          type="month"
          customTrigger={
            <div className="font-black text-sm text-gray-800 px-2">
              {currentDate.getFullYear()}년 {currentDate.getMonth() + 1}월
            </div>
          }
        />
        <button onClick={onNextMonth} className="w-9 h-9 hover:bg-gray-50 rounded-xl transition flex items-center justify-center">
          <ChevronRight size={18} className="text-gray-400" />
        </button>
      </div>
    </div>
  );
}
